import React from 'react'
import { Redirect } from 'react-router-dom'
import { Routes } from '../config/routes'

import { VendorGuard } from '../guards'
import type { RouteConfig } from '../types'
import { AuthLayout } from '../layouts'
import { EZWorkRoot } from '../../containers/EZWork/EZWorkRoot'
import { ViewSubsPage } from '../../containers/EZWork/ViewSubsPage'
import { VendorHelp } from '../../containers/Help'
import { VendorSettings } from '../../containers/VendorSettings'
import { VendorAnalytics } from '../../containers/Analytics'
import { VendorProjectAnalyticsPage } from '../../containers/VendorAnalytics'
import { NationalPropertyList } from '../../containers/NationalPropertyList'

const LEGACY_VIEW_SUBS_PATH = '/view-subs'

const ViewSubsLegacyRedirect: React.FC = () =>
    React.createElement(Redirect, { to: Routes.vendor.subs })

export const vendorRoutes: RouteConfig[] = [
    {
        path: Routes.vendor.ezwork,
        component: EZWorkRoot,
        layout: AuthLayout,
        guard: VendorGuard,
    },
    {
        path: Routes.vendor.subsPricing,
        component: ViewSubsPage,
        layout: AuthLayout,
        guard: VendorGuard,
        exact: true,
    },
    {
        path: Routes.vendor.subsPricingRoot,
        component: ViewSubsPage,
        layout: AuthLayout,
        guard: VendorGuard,
        exact: true,
    },
    {
        path: Routes.vendor.subs,
        component: ViewSubsPage,
        layout: AuthLayout,
        guard: VendorGuard,
        exact: true,
    },
    {
        path: LEGACY_VIEW_SUBS_PATH,
        component: ViewSubsLegacyRedirect,
        layout: AuthLayout,
        guard: VendorGuard,
        exact: true,
    },
    {
        path: Routes.vendor.settings,
        component: VendorSettings,
        layout: AuthLayout,
        guard: VendorGuard,
    },
    {
        path: Routes.vendor.help,
        component: VendorHelp,
        layout: AuthLayout,
        guard: VendorGuard,
    },
    {
        path: Routes.vendor.analytics,
        component: VendorAnalytics,
        layout: AuthLayout,
        guard: VendorGuard,
    },
    {
        path: Routes.vendor.projectAnalytics,
        component: VendorProjectAnalyticsPage,
        layout: AuthLayout,
        guard: VendorGuard,
        exact: true,
    },
    {
        path: Routes.vendor.nationalPropertyList,
        component: NationalPropertyList,
        layout: AuthLayout,
        guard: VendorGuard,
    },
]
